import { render } from "./CardAvatar.vue?vue&type=template&id=5c7410f5&scoped=true"
import script from "./CardAvatar.vue?vue&type=script&lang=js"
export * from "./CardAvatar.vue?vue&type=script&lang=js"

import "./CardAvatar.vue?vue&type=style&index=0&id=5c7410f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7410f5"]])

export default __exports__